'use strict';

require('../../style/index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/icon/style/index.js
 ** module id = 188
 ** module chunks = 0
 **/